import { userNamespace } from "@/store/modules/user";
import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
const synth = window.speechSynthesis;

@Component
export default class SpeechSynthesis extends Vue {
  @Getter("speechSynthesisEnabled", userNamespace)
  speechSynthesisEnabled!: boolean;

  @Getter("supportsSpeechSynthesis", userNamespace)
  supportsSpeechSynthesis!: boolean;

  @Action("setSpeechSynthesisEnabled", userNamespace)
  setSpeechSynthesisEnabled!: Function;

  // This needs to be a queue if we want more time between them
  speak(text: string) {
    if (!this.speechSynthesisEnabled || !this.supportsSpeechSynthesis) {
      return;
    }
    const utterThis = new SpeechSynthesisUtterance(text);

    utterThis.pitch = 1;
    utterThis.rate = 0.9;
    const perferredVoiceList = this.preferredVoices();
    if (perferredVoiceList.length) {
      // This will just take the first name in the list, probably Samantha
      utterThis.voice = perferredVoiceList[0];
    }
    synth.speak(utterThis);
  }

  private preferredVoices() {
    return synth.getVoices().filter(v => {
      return v.localService === true && this.isPreferredName(v.name);
    });
  }
  private isPreferredName(name: string) {
    const nameToCheck = name.toLowerCase();
    let hasName = false;
    this.nameList
      .map(n => n.toLowerCase())
      .forEach(preferredName => {
        if (nameToCheck.indexOf(preferredName) !== -1) {
          hasName = true;
        }
      });
    return hasName;
  }
  nameList = ["Samantha", "Zira"];

  mounted() {
    this.checkIfSpeechEnabled();
  }

  checkIfSpeechEnabled() {
    if (
      this.speechSynthesisEnabled ||
      typeof SpeechSynthesisUtterance === "undefined"
    ) {
      return;
    }
    const utterThis = new SpeechSynthesisUtterance("");
    utterThis.addEventListener("error", event => {
      if (event.error === "synthesis-failed") {
        this.setSpeechSynthesisEnabled(true);
      }
    });
    utterThis.addEventListener("end", () => {
      // Most browsers (Safari / FF / IE?) do not require a click
      this.setSpeechSynthesisEnabled(true);
    });
    synth.speak(utterThis);
  }
}
